import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Leads from "@/pages/leads/page";
import Bounty from "@/pages/bounty/page";
import Submit from "@/pages/submit/page";
import Faq from "@/pages/faq/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "leads", element: <Leads /> },
      { path: "bounty", element: <Bounty /> },
      { path: "submit", element: <Submit /> },
      { path: "faq", element: <Faq /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;